<template>
  <b-modal
    id="modal-workplace-due-date-rules"
    ref="workplaceDueDateRulesModal"
    :title="workplaceName ? `Contrato: ${workplaceName}` : ''"
    hide-footer
    size="xl"
    centered
    no-close-on-backdrop
    @shown="onModalShown"
  >
    <div class="text-right mb-2">
      <b-button
        variant="primary"
        :disabled="loading"
        @click="handleSave"
      >
        <span class="d-none d-sm-inline">Salvar</span>
      </b-button>
    </div>
    <workplace-due-date-rules-form
      ref="workplaceDueDateRulesForm"
    />
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BButton, BModal, VBModal } from 'bootstrap-vue'
import WorkplaceDueDateRulesForm from './WorkplaceDueDateRulesForm.vue'
import useWorkplaceDueDateRulesSave from './useWorkplaceDueDateRulesSave'

export default {
  components: {
    BButton,
    BModal,
    WorkplaceDueDateRulesForm,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup(_, { emit }) {
    const workplaceDueDateRulesModal = ref(null)
    const workplaceDueDateRulesForm = ref(null)
    const workplaceName = ref(null)
    const pendingWorkplace = ref(null)

    function hide() {
      workplaceDueDateRulesModal.value.hide()
    }

    const { loading, saveDueDateRules } = useWorkplaceDueDateRulesSave(
      () => emit('refetch-data'),
      hide,
    )

    function show(workplace) {
      workplaceName.value = workplace.name
      pendingWorkplace.value = workplace
      workplaceDueDateRulesModal.value.show()
    }

    function onModalShown() {
      if (pendingWorkplace.value && workplaceDueDateRulesForm.value) {
        workplaceDueDateRulesForm.value.loadWorkplace(pendingWorkplace.value)
        pendingWorkplace.value = null
      }
    }

    function handleSave() {
      saveDueDateRules(workplaceDueDateRulesForm.value)
    }

    return {
      workplaceDueDateRulesModal,
      workplaceDueDateRulesForm,
      workplaceName,
      loading,
      show,
      onModalShown,
      hide,
      handleSave,
    }
  },
}
</script>
